// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { RootStore } from "../../../RootStore";
import { JusticeInvolvedPerson } from "../../../WorkflowsStore";
import { CaseloadOpportunitiesPresenter } from "../../../WorkflowsStore/presenters/CaseloadOpportunitiesPresenter";
import { Resident } from "../../../WorkflowsStore/Resident";

export class AllCaseloadsTablePresenter extends CaseloadOpportunitiesPresenter {
  constructor(public rootStore: RootStore) {
    super(rootStore.workflowsStore);
  }

  get canRenderTable() {
    const {
      workflowsStore: { activeSystem },
      tenantStore: { currentTenantId },
    } = this.rootStore;

    if (!currentTenantId) return;

    const applicableStates = ["US_MI", "US_TN"];

    return (
      activeSystem === "INCARCERATION" &&
      applicableStates.includes(currentTenantId)
    );
  }

  get people(): Resident[] {
    // @ts-expect-error the activeSystem check in canRenderTable()
    // ensures these are Residents
    return this.rootStore.workflowsStore.searchStore.caseloadPersons;
  }

  updateSelectedPerson(person: JusticeInvolvedPerson) {
    this.rootStore.workflowsStore.updateSelectedPerson(person.pseudonymizedId);
  }

  get selectedResident(): Resident | undefined {
    // @ts-expect-error the activeSystem check in canRenderTable()
    // ensures this person is a Resident
    return this.rootStore.workflowsStore.selectedPerson;
  }
}
